/**
 * Blocker #13: display label for a production, accounting for personal
 * "My Space" workspaces.
 *
 * - Owner viewing their own personal space → "My Space"
 * - Someone else viewing a personal space → "<display_name>'s Space"
 * - Non-personal production → production_name (or company_name fallback)
 *
 * production shape expected: { is_personal, owner_user_id, owner_display_name?,
 * production_name, company_name }
 * authUser shape expected: { id }
 */
export function spaceLabelFor(production, authUser) {
  if (!production) return '';
  if (production.is_personal) {
    if (authUser && production.owner_user_id === authUser.id) return 'My Space';
    const name = production.owner_display_name || 'User';
    return `${name}'s Space`;
  }
  return production.production_name || production.company_name || '';
}

export default spaceLabelFor;
